import React, { useState, useEffect } from "react";
import Sidebar from '../../../composant_reutilisable/sidebar';
import Navbar from "../../../composant_reutilisable/navbar";
import useAuth from '../../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import { Modal, Button, Form, ProgressBar } from "react-bootstrap";
import {
    FaEdit, FaPlus, FaTrash, FaEllipsisV,
    FaSortAmountUp, FaSortAmountDown,
    FaArrowLeft,
    FaArrowRight,
    FaBoxOpen,
    FaLeaf,
    FaFileImport,
    FaChevronUp,
    FaChevronDown,
    FaQuestionCircle,
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Pas_acces from "../../../composant_reutilisable/pas_acces";
import { FaRoadBarrier } from "react-icons/fa6";

const ListeEssieux = () => {
    useAuth();
    const navigate = useNavigate();

    const [showInfo, setShowInfo] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({
        key: "id",
        direction: "descending",
    });
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    const [essieux, setEssieu] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModifierModal, setShowModifierModal] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Type essieu ";
        }
    }, [user_id]);

    const [showModal, setShowModal] = useState(false);
    const [nouveauEssieu, setNouveauEssieu] = useState({
        type_essieu: "",
        charge_max: "",
        description: ""
    });

    const [essieuSelectionne, setEssieuSelectionne] = useState({
        type_essieu: '',
        charge_max: '',
        description: ''
    });

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
        setAlertModal({ message: '', type: '' });
    }

    // Récupération des essieux
    const fetchEssieux = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-essieu/");
            if (response.ok) {
                const data = await response.json();
                setEssieu(data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des listes essieux:", error);
        }
    };

    useEffect(() => {
        fetchEssieux();
    }, []);

    // Filtrage 
    const essieuFiltrees = essieux.filter(essieu =>
        essieu?.type_essieu?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        essieu?.charge_max?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        essieu?.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Tri des données
    const essieuTriees = [...essieuFiltrees].sort((a, b) => {
        if (sortConfig.key) {
            const valueA = a[sortConfig.key]?.toString().toLowerCase() || "";
            const valueB = b[sortConfig.key]?.toString().toLowerCase() || "";
            if (valueA < valueB) return sortConfig.direction === "ascending" ? -1 : 1;
            if (valueA > valueB) return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
    });

    // Pagination
    const totalItems = essieuFiltrees.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const essieuAffichees = essieuTriees.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelectionEssieu = (essieu) => {
        setEssieuSelectionne(essieu);
    };

    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    // Gestion du formulaire d'ajout
    const handleChange = (e) => {
        const { name, value } = e.target;
        setNouveauEssieu(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAjouterEssieu = async () => {
        const erreurs = [];

        if (!nouveauEssieu.type_essieu.trim()) {
            erreurs.push("Le type d'essieu est obligatoire.");
        }
        if (!nouveauEssieu.charge_max.trim()) {
            erreurs.push("La charge maximale est obligatoire.");
        }


        if (erreurs.length > 0) {
            showAlertModal(erreurs.join(" "), "danger");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-essieu/${user_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(nouveauEssieu),
            });

            if (response.ok) {
                fetchEssieux();
                setNouveauEssieu("");
                handleCloseModal();
                showAlert("Essieu ajouté avec succès", "success");
            } else {
                const errorData = await response.json();
                showAlertModal(errorData.error || "Erreur lors de l'ajout du type d'essieu", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlertModal("Une erreur est survenue. Veuillez réessayer.", "danger");
        }
    };

    const handleShowDeleteModal = (essieu) => {
        setEssieuSelectionne(essieu);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleDeleteEssieu = async () => {
        if (essieuSelectionne) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-essieu/${essieuSelectionne.id}/${user_id}/`, {
                    method: 'DELETE',
                });

                if (response.ok) {
                    setEssieu(essieux.filter((essieu) => essieu.id !== essieuSelectionne.id));
                    setEssieuSelectionne(null);
                    showAlert('Essieu supprimé avec succès !');
                } else {
                    console.error('Erreur lors de la suppression de l\'essieu');
                    showAlert('Erreur lors de la suppression', 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert('Erreur réseau', 'danger');
            } finally {
                setShowDeleteModal(false);
            }
        }
    };

    const handleShowModifierModal = (essieu) => {
        setEssieuSelectionne(essieu);
        setShowModifierModal(true);
    };

    const handleCloseModifierModal = () => {
        setShowModifierModal(false);
    };

    const handleModifierEssieu = async () => {
        if (essieuSelectionne) {
            const erreurs = [];

            if (!essieuSelectionne.type_essieu.trim()) {
                erreurs.push("Le type d'essieu est obligatoire.");
            }
            if (!essieuSelectionne.charge_max.trim()) {
                erreurs.push("La charge maximale est obligatoire.");
            }

            if (erreurs.length > 0) {
                showAlertModal(erreurs.join(" "), "danger");
                return;
            }

            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/modifier-essieu/${essieuSelectionne.id}/${user_id}/`,
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            type_essieu: essieuSelectionne.type_essieu,
                            charge_max: essieuSelectionne.charge_max,
                            description: essieuSelectionne.description
                        }),
                    }
                );

                if (response.ok) {
                    fetchEssieux();
                    showAlert('Essieu modifié avec succès !');
                } else {
                    console.error('Erreur lors de la modification de l\'essieu');
                    showAlert('Erreur lors de la modification', 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert('Erreur réseau', 'danger');
            } finally {
                setShowModifierModal(false);
            }
        }
    };

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Elementaires")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2></h2>
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaRoadBarrier size={25} className='mr-2' />Type Essieu
                                    {/* <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span> */}
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'admin-elementaires'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small>Administration des types d'essieux.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Elementaires`}> Elémentaires</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Type essieu
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`m-3 alert alert-${alert.type} row justify-content-between position-relative`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des types essieux </h5>
                            <div className="d-flex mt-md-0" style={{ gap: '10px' }}>
                                <button className="btn btn-success mr-2 d-flex align-items-center justify-content-center" onClick={handleOpenModal}>
                                    <FaPlus />
                                    <span className="d-none d-sm-inline ml-2">Ajouter</span>
                                </button>

                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="me-2">
                                                <select
                                                    value={itemsPerPage}
                                                    onChange={handleItemsPerPageChange}
                                                    className="form-select bg-default p-1"
                                                    style={{
                                                        width: "auto",
                                                        border: "1px black solid",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                            </div>
                                            <div className="row justify-content-center align-items-center">
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control mr-2"
                                                    style={{ maxWidth: "150px", width: "100%" }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                <thead>
                                                    <tr>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort("type_essieu")}>
                                                            Type essieu
                                                            {sortConfig.key === "type_essieu"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("charge_max")}>
                                                            Charge maximale
                                                            {sortConfig.key === "charge_max"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("description")}>
                                                            Description
                                                            {sortConfig.key === "description"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-center">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <tr>
                                                            <td colSpan="2" className="text-center">Chargement...</td>
                                                        </tr>
                                                    ) : essieuAffichees.length > 0 ? (
                                                        essieuAffichees.map((essieu) => (
                                                            <tr key={essieu.id}>
                                                                <td className="d-none d-md-table-cell text-justify">{essieu.type_essieu}</td>
                                                                <td className="d-none d-md-table-cell text-center">{essieu.charge_max}</td>
                                                                <td className="d-none d-md-table-cell text-center">{essieu.description}</td>
                                                                <td className="text-center" style={{ position: 'relative' }}>
                                                                    <div>
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setOpenDropdownId(openDropdownId === essieu.id ? null : essieu.id);
                                                                            }}
                                                                            style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                padding: '0 5px',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        >
                                                                            <FaEllipsisV title="Actions" />
                                                                        </button>

                                                                        {openDropdownId === essieu.id && (
                                                                            <div
                                                                                style={{
                                                                                    position: 'fixed',
                                                                                    zIndex: 1000,
                                                                                    minWidth: '150px',
                                                                                    right: '100px',
                                                                                    backgroundColor: 'white',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '4px',
                                                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                                                    maxHeight: '150px',
                                                                                    overflowY: 'auto',
                                                                                    scrollbarWidth: 'thin',
                                                                                    scrollbarColor: '#ddd #f8f9fa',
                                                                                }}
                                                                                className="custom-scrollbar"
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowModifierModal(essieu);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaEdit className="mr-2" style={{ color: "blue" }} size={14} />
                                                                                    <span>Modifier</span>
                                                                                </div>

                                                                                <div style={{ borderTop: '1px solid #eee' }} />

                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowDeleteModal(essieu);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaTrash className="mr-2" style={{ color: "red" }} size={14} />
                                                                                    <span>Supprimer</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="2" className="text-center">Aucun essieu trouvé.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div>
                                                {essieuFiltrees.length === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Affichage de ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, essieuFiltrees.length)} sur ${essieuFiltrees.length}`}
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                    className={`btn ${currentPage === 1 ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === 1}
                                                >
                                                    <FaArrowLeft />
                                                </button>

                                                {(() => {
                                                    const pagesToShow = 5;
                                                    let startPage = Math.max(
                                                        1,
                                                        currentPage - Math.floor(pagesToShow / 2)
                                                    );
                                                    let endPage = Math.min(
                                                        totalPages,
                                                        startPage + pagesToShow - 1
                                                    );

                                                    if (endPage - startPage < pagesToShow - 1) {
                                                        startPage = Math.max(
                                                            1,
                                                            endPage - pagesToShow + 1
                                                        );
                                                    }

                                                    const pageButtons = [];

                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageButtons.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => setCurrentPage(i)}
                                                                className={`btn ${currentPage === i
                                                                    ? "btn-default"
                                                                    : "btn-light"
                                                                    } mx-1`}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }

                                                    return pageButtons;
                                                })()}
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                    className={`btn ${currentPage === totalPages ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <FaArrowRight />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal d'enregistrement */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Ajouter un parc tampon</Modal.Title>
                </Modal.Header>
                {alertModal.message && (
                    <div className={`m-2 alert alert-${alertModal.type} row justify-content-between position-relative`}>
                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                        <span onClick={fermerNotif} style={{ cursor: 'pointer' }}>
                            <i className='fa fa-close'></i>
                        </span>
                    </div>
                )}
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formEssieu">
                            <Form.Label className="">Type d'essieu</Form.Label>
                            <Form.Control
                                type="text"
                                name="type_essieu"
                                value={nouveauEssieu?.type_essieu || ''}
                                onChange={handleChange}
                                placeholder="Type d'essieu"
                            />
                            <Form.Label className="mt-2">Charge maximale (tonnes)</Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                name="charge_max"
                                value={nouveauEssieu?.charge_max || ''}
                                onChange={handleChange}
                                placeholder="Charge maximale en tonnes"
                            />
                            <Form.Label className="mt-2">Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                name="description"
                                value={nouveauEssieu?.description || ''}
                                onChange={handleChange}
                                placeholder="Description du type d'essieu (facultatif)"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleAjouterEssieu}>
                        <strong>Ajouter</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer le type d'essieu <strong>{essieuSelectionne?.type_essieu}</strong> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleDeleteEssieu}>
                        <strong>Supprimer</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de modification */}
            <Modal show={showModifierModal} onHide={handleCloseModifierModal}>
                <Modal.Header>
                    <Modal.Title>Modifier le type essieu</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formEssieu">
                            <Form.Label className="">Type essieu</Form.Label>
                            <Form.Control
                                type="text"
                                value={essieuSelectionne?.type_essieu || ''}
                                onChange={(e) =>
                                    setEssieuSelectionne({ ...essieuSelectionne, type_essieu: e.target.value })
                                }
                            />

                            <Form.Label className="">Charge maximale (tonnes)</Form.Label>
                            <Form.Control
                                type="number"
                                min="0"
                                value={essieuSelectionne?.charge_max || ''}
                                onChange={(e) =>
                                    setEssieuSelectionne({ ...essieuSelectionne, charge_max: e.target.value })
                                }
                            />
                            <Form.Label className="mt-2">Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                name="description"
                                value={essieuSelectionne?.description || ''}
                                onChange={(e) =>
                                    setEssieuSelectionne({ ...essieuSelectionne, description: e.target.value })
                                }
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModifierModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleModifierEssieu}>
                        <strong>Modifier</strong>
                    </Button>
                </Modal.Footer>
            </Modal>


        </div>
    );
};

export default ListeEssieux;